import constants from 'client/constants';

export type FooterColumn = {
  key: string;
  title: string;
  items: FooterDataItem[];
};

export type FooterDataItem = {
  label: string;
  link?: string;
  type?: FooterItemType;
  icon?: string;
};

type FooterItemType = 'title' | 'link';

const footerData: FooterColumn[] = [
  {
    key: 'get-started',
    title: 'Get Started',
    items: [
      {
        label: 'Sign Up',
        link: '/signup'
      },
      {
        label: 'Course Library',
        link: '/subjects'
      },
      {
        label: 'Schedule a Demo',
        link: 'https://albert-licenses.typeform.com/to/Yv8f75Vi?utm_source=site-footer'
      }
    ]
  },
  {
    key: 'company',
    title: 'Company',
    items: [
      {
        label: 'About Us',
        link: '/about-our-team'
      },
      {
        label: 'Careers',
        link: 'https://careers.albert.io'
      },
      {
        label: 'Blog',
        link: '/blog'
      }
    ]
  },
  {
    key: 'explore',
    title: 'Explore',
    items: [
      {
        label: 'For Teachers',
        link: '/explore/for-teachers'
      },
      {
        label: 'For Admins',
        link: '/explore/for-admins'
      },
      {
        label: 'For Students',
        link: '/explore/for-students'
      },
      {
        label: 'Research',
        link: '/explore/research'
      },
      {
        label: 'Professional Development',
        link: '/explore/professional-development'
      },
      {
        label: 'Albert Stories',
        link: '/explore/testimonials'
      },
      {
        label: 'Find Your State',
        link: '/explore/states/'
      }
    ]
  },
  {
    key: 'products',
    title: 'Products',
    items: [
      {
        label: 'Adaptive',
        link: '/products/adaptive'
      },
      {
        label: 'AP® Question Banks',
        link: '/products/ap-question-banks'
      },
      {
        label: 'EOC Question Banks',
        link: '/products/eoc-question-banks'
      },
      {
        label: 'Core Question Banks',
        link: '/products/core-question-banks'
      }
    ]
  },
  {
    key: 'contact-us',
    title: 'Contact us',
    items: [
      {
        label: 'SUPPORT',
        type: 'title'
      },
      {
        label: 'Help Center',
        icon: 'headset',
        link: 'https://help.albert.io'
      },
      {
        label: constants.CONTACT.EMAIL.SUPPORT,
        icon: 'envelope',
        link: `mailto:${constants.CONTACT.EMAIL.SUPPORT}`
      },
      {
        label: 'SALES',
        type: 'title'
      },
      {
        label: constants.CONTACT.EMAIL.SALES,
        icon: 'envelope',
        link: `mailto:${constants.CONTACT.EMAIL.SALES}`
      }
    ]
  }
];

export const getFooterData = (hasValidSession: boolean): FooterColumn[] => {
  // add login link to footer if the user is unauthenticated - first column.
  if (!hasValidSession) {
    const loginItem: FooterDataItem = {
      label: 'Log In',
      link: '/log-in'
    };
    const [firstColumn, ...restColumns] = footerData;
    const footerDataUpdated: FooterColumn[] = [
      {...firstColumn, items: [loginItem, ...firstColumn.items]},
      ...restColumns
    ];

    return footerDataUpdated;
  }
  return footerData;
};
